module.exports = __webpack_public_path__ + "media/images/emblems/Schmiedrued-blason-5bb9202cb56ef5ac856f563fe854dce7.png";